import React from 'react';
import { Link } from 'react-router-dom';
import CelestialLayout from './CelestialLayout';
import TopNav from './TopNav';
import SiteFooter from './SiteFooter';

interface LegalPageShellProps {
  title: string;
  children: React.ReactNode;
}

export default function LegalPageShell({ title, children }: LegalPageShellProps) {
  return (
    <CelestialLayout>
      <TopNav />
      <main className="celestial-main">
        <article className="legal-prose">
          <h1>{title}</h1>
          {children}
        </article>
      </main>
      <SiteFooter />
    </CelestialLayout>
  );
}

export function LegalFallback({ href, label }: { href: string; label: string }) {
  return (
    <div className="celestial-glass" style={{ padding: '1.25rem', marginTop: '1rem' }}>
      <p className="celestial-body-lg" style={{ fontSize: '0.95rem', margin: 0 }}>
        İçerik şu an yüklenemedi.{' '}
        <a href={href} target="_blank" rel="noopener noreferrer">
          {label}
        </a>
        üzerinden metni açabilirsiniz.
      </p>
      <p style={{ marginTop: '1rem' }}>
        <Link to="/" className="celestial-btn-ghost">
          Ana sayfaya dön
        </Link>
      </p>
    </div>
  );
}
